import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, createClasses } from '@kp/react-ui';

const classes = createClasses({
  content: {
    padding: '16px 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  list: {
    listStyle: 'decimal',
    counterReset: 'section 0',
    margin: '8px 0px 0px 24px',
    gap: '24px',
    display: 'flex',
    flexDirection: 'column',
  },
  listItem: {
    counterIncrement: 'section 1',
  },
  subList: {
    listStyle: 'none',
    counterReset: 'subsection 0',
    ' > li': {
      counterIncrement: 'subsection 1',
    },
    ' > li::before': {
      content: 'counter(section) "." counter(subsection) " "',
      fontWeight: 'inherit',
    },
  },
});

export const LegalTermsAndConditions: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={classes.content}>
      <Typography variant="headlineMedium">
        {t('legals.termsAndConditions.title')}
      </Typography>
      <Typography variant="titleLarge">
        {t('legals.termsAndConditions.introduction.title')}
      </Typography>
      <Typography variant="bodyMedium">
        {t('legals.termsAndConditions.introduction.paragraph1')}
      </Typography>
      <ul>
        <Typography component="li" variant="bodyMedium">
          {t('legals.termsAndConditions.introduction.paragraph2')}
        </Typography>
      </ul>
      <ol className={classes.list}>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section1.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section1.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section1.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section1.subsection3')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section1.subsection4')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section1.subsection5')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section1.subsection6')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section2.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section2.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section2.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section2.subsection3')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section2.subsection4')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section3.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section3.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section3.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section3.subsection3')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section3.subsection4')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section3.subsection5')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section3.subsection6')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section3.subsection7')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section4.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section4.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section4.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section4.subsection3')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section5.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section5.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section5.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section5.subsection3')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section5.subsection4')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section5.subsection5')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section6.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section6.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section6.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section6.subsection3')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section6.subsection4')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section6.subsection5')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section6.subsection6')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section7.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section7.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section7.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section7.subsection3')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section7.subsection4')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section7.subsection5')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section8.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection3')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection4')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection5')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection6')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection7')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection8')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection9')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section8.subsection10')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section9.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section9.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section9.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section9.subsection3')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section9.subsection4')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section9.subsection5')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section9.subsection6')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section10.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section10.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section10.subsection2')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section11.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection2')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection3')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection4')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection5')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection6')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection7')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection8')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection9')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section11.subsection10')}
            </Typography>
          </ol>
        </Typography>
        <Typography
          component="li"
          variant="titleMedium"
          className={classes.listItem}
        >
          {t('legals.termsAndConditions.section12.title')}
          <ol className={classes.subList}>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section12.subsection1')}
            </Typography>
            <Typography component="li" variant="bodyMedium">
              {t('legals.termsAndConditions.section12.subsection2')}
            </Typography>
          </ol>
        </Typography>
      </ol>
    </div>
  );
};
